export default function MySQL_EXAMPLES() {
  return (
    <div>
      <h2>MySQL_EXAMPLES</h2>    </div>
  );
}